
import { Injectable } from '@angular/core'
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class YearlyResultByWeekReportShopService {

  constructor(private http: HttpClient) { }
    getWeekNoList(requestData:RequestData): Observable<any> {
            return this.http.post(environment.baseUrl+'/week-def/get',requestData);
        
          }
          
        getYtdBranchViewList(requestData: any): Observable<any> {
          return this.http.post(environment.baseUrl+'/hq/ytd-result-by-branch-report/get', requestData);
      
        }
      
        yearlyResultByWeekExportList(data: any): Observable<any> {
          // Add responseType: 'blob' to indicate you expect a binary response
          return this.http.post(
            environment.baseUrl+'/reports/yearly-result-by-week', 
            data, 
            { responseType: 'blob' }
      );
      }
}
